import { Component, OnInit, Input, HostBinding, Output, HostListener, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit {
  @Input()
  @HostBinding('class.active') selected: boolean = false;
  @Output() select = new EventEmitter()
  
  constructor() { }
  
  ngOnInit() {
  }
  
  @HostListener('click', ['$event.target'])onclick(btn) {
    this.select.emit(this)
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/chips/chip/chip.component.ts